import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProcessStepper from "../../../../components/stepperprocess/ProcessStepper";
import "./process.css";
import { capitalizeFirst } from "../../../../utils/commonServices";

const Companyprocess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const company = location.state?.company;

  if (!company) {
    return (
      <div className="container py-4">
        <p>
          No company selected.{" "}
          <button className="btn btn-link" onClick={() => navigate(-1)}>
            Go back
          </button>
        </p>
      </div>
    );
  }
  const handleApprove = () => {
    navigate("/personal-details", { state: { company, userType: "Company" } });
  };

  return (
    <div className="" style={{ minHeight: "100vh" }}>
      <div>
        <ProcessStepper currentStep={0} userType={"Company"} />
      </div>
      <div className="flex-grow-1">
        {/* Your Company Details Card */}
        <div className="p-4 shadow rounded bg-white">
          <div className="d-flex">
            <div className="col-6">
              <h5>
                Brand or Whitelabel:{" "}
                <span className="text-muted">{capitalizeFirst(company?.member_firm_name)}</span>
              </h5>
              <p>
                Business Type: <span className="text-muted">{company?.member_business_type}</span>
              </p>
              <p>
                Address:{" "}
                <span className="text-muted">{company.member_firm_address}</span>
              </p>
            </div>

            <div className="col-6">
              <p style={{fontSize:'16px'}}>Shop or Office Image</p>
              <img
                src={
                  company.member_shop_photo_url ||
                  "https://images.pexels.com/photos/3182761/pexels-photo-3182761.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                }
                alt="Company"
                className="img-fluid rounded shadow"
                
              />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-3 mt-4">
            <button className="btn btn-primary px-4" onClick={handleApprove}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Companyprocess;
